export default "__VITE_ASSET__CKOBcpmk__"